// Legacy shim → use the npm build with timezone data (1970–2030)
//(You can delete this shim later after replacing legacy imports or after loading moment-timezone once in boot-client.ts.)
module.exports = require('moment-timezone/builds/moment-timezone-with-data-1970-2030.js');